// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@property --pgPercentage {
  syntax: "<number>";
  inherits: false;
  initial-value: 0;
}
@keyframes growProgressBar {
  0%, 33% {
    --pgPercentage: 0;
  }
}
.text_description {
  line-height: 1.8;
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  row-gap: 4rem;
  column-gap: 2rem;
}
.grid-container > * > span:first-child {
  --size: 6rem;
  --value: 0;
  --pgPercentage: var(--value);
  color: var(--surface-900);
  animation: growProgressBar 3s 2s forwards;
  width: var(--size);
  height: var(--size);
  border-radius: 50%;
  display: grid;
  place-items: center;
  transition: filter 0.5s ease-in-out;
  background: radial-gradient(circle at center, var(--surface-background) 65%, transparent 65.99%), conic-gradient(#844b92 0, #d49a20 calc(var(--pgPercentage) * 1%), var(--surface-background) 0);
}
.grid-container > *:hover span:first-child {
  filter: drop-shadow(0px 0px 4px var(--primary-color));
}`, "",{"version":3,"sources":["webpack://./src/app/modules/home/components/speed/speed.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;AACF;AAEA;EACE;IAEE,iBAAA;EADF;AACF;AAIA;EACE,gBAAA;AAFF;;AAKA;EACE,aAAA;EACA,qCAAA;EACA,aAAA;EACA,gBAAA;AAFF;AAKI;EACE,YAAA;EACA,UAAA;EACA,4BAAA;EACA,yBAAA;EACA,yCAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mCAAA;EACA,gMAAA;AAHN;AAeI;EACE,qDAAA;AAbN","sourcesContent":["@property --pgPercentage {\r\n  syntax: \"<number>\";\r\n  inherits: false;\r\n  initial-value: 0;\r\n}\r\n\r\n@keyframes growProgressBar {\r\n  0%,\r\n  33% {\r\n    --pgPercentage: 0;\r\n  }\r\n}\r\n\r\n.text_description {\r\n  line-height: 1.8;\r\n}\r\n\r\n.grid-container {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, 1fr);\r\n  row-gap: 4rem;\r\n  column-gap: 2rem;\r\n\r\n  > * {\r\n    > span:first-child {\r\n      --size: 6rem;\r\n      --value: 0;\r\n      --pgPercentage: var(--value);\r\n      color: var(--surface-900);\r\n      animation: growProgressBar 3s 2s forwards;\r\n      width: var(--size);\r\n      height: var(--size);\r\n      border-radius: 50%;\r\n      display: grid;\r\n      place-items: center;\r\n      transition: filter 0.5s ease-in-out;\r\n      background: radial-gradient(\r\n          circle at center,\r\n          var(--surface-background) 65%,\r\n          transparent 65.99%\r\n        ),\r\n        conic-gradient(\r\n          #844b92 0,\r\n          #d49a20 calc(var(--pgPercentage) * 1%),\r\n          var(--surface-background) 0\r\n        );\r\n    }\r\n\r\n    &:hover span:first-child {\r\n      filter: drop-shadow(0px 0px 4px var(--primary-color));\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
